import React from "react";
import { useParams } from "react-router-dom";

import RecoverPasswordComponent from "@/components/screens/RecoverPassword";
import { RECOVER_PASSWORD } from "@/messages/recoverPassword/recover-password.messages";
import { type Language } from "@/types/language.types";

const RecoverPassword: React.FC = () => {
  useParams<{ lang?: Language }>();
  return <RecoverPasswordComponent messages={RECOVER_PASSWORD} />;
};

export default RecoverPassword;
